import {authentication} from "@/services/auth";
import {Device} from "@/services/Device";
import {responses} from "@/utils/responses";
import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "@/utils/utils";
import {errorHandler} from "@/services/errorHandler";
import queryStringify from "qs-stringify";
import { VueEditor } from 'vue2-editor';
import {dateTimeManager} from "@/services/TimeManager";
import { Imeis } from "@/services/Imeis";
import { initUsageTracker } from "@/services/UsageTracker";

Vue.component('vue-editor', VueEditor);

// Initialize usage tracking
initUsageTracker({ appKey: 'kazang-pos' });
window.serverApi = `https://overflow.pos.co.zm/OnlineSalesServer/`
// window.serverApi = `http://localhost:8286/kazangApi/`

window.kazangApi = `https://realtime.pos.co.zm:8443/kazangApi/api/`
// window.kazangApi = `http://localhost:8286/kazangApi/api/`

// LIVE GATEWAY (KazangPaymentGateway on LNA, Cloudflare-fronted):
// Production path uses /KazangPaymentGateway/* — the test deploy lives under
// /Test_KazangPaymentGateway/* and uses the same spring context path (LNA's
// nginx strips the /Test_ prefix before forwarding to the test unit).
// 443 is Cloudflare-proxied — no explicit port.
// Vue dev server HMR will pick this up — refresh the browser tab.
window.gateWayApi = `https://lna.pos.co.zm/KazangPaymentGateway/V2/GateWay/`
// window.gateWayApi = `http://192.168.1.175:8082/KazangPaymentGateway/V2/GateWay/`
// window.gateWayImage = `http://192.168.1.175:8082/KazangPaymentGateway/`
window.gateWayImage = `https://lna.pos.co.zm/KazangPaymentGateway/`

window.franchiseTomcatApi = `https://overflow.pos.co.zm/Franchise_OnlineServer/`
// window.franchiseTomcatApi = `http://localhost:8286/kazangApi/`

window.ticketApi = 'https://lna.pos.co.zm/TicketApp/'
// window.ticketApi = `http://192.168.1.177:8086/TicketApp/`;

window.SmartInvoice = `https://lna.pos.co.zm/SynergyApi/api/v1/`

window.backOfficeTomcatApi = `https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/`
// window.backOfficeTomcatApi = `http://localhost:8286/kazangApi/`

window.backOfficePlatform = `https://admin.chrilantech.com`;

window.synergyApi = `https://lna.pos.co.zm/TicketApp/`
// window.synergyApi = `http://192.168.1.177:8081/SynergyApi2/api/v1/`

window.serverApiGET = franchiseTomcatApi+`proxyApi/onlineSalesServer/GET`;

window.backOfficeApiPOST = franchiseTomcatApi+`proxyApi/lytSoftBackOffice/POST`;
window.backOfficeApiGET = franchiseTomcatApi+`proxyApi/lytSoftBackOffice/GET`;

window.gateWayApiPOST = franchiseTomcatApi+`proxyApi/gateWay/POST`;
window.gateWayApiGET = franchiseTomcatApi+`proxyApi/gateWay/GET`;

window.subscriptionApiPOST = franchiseTomcatApi+`proxyApi/subscriptionApi/POST`;
window.subscriptionApiGET = franchiseTomcatApi+`proxyApi/subscriptionApi/GET`;
window.subscriptionApi = `https://overflow.pos.co.zm/SubscriptionManager/api/`;
// Kazang POS HelpDesk backend — used by checkProductAccess to look up a store's
// product_id directly from burntofi_latestreg.customer (bypasses the SubscriptionManager's
// MainCustomerID requirement, so the Lytning block works for stores whose device-cached
// mainCustomerID doesn't match).
// window.kazangHelpDeskApi = `https://lna.pos.co.zm/KazangHelpDesk/api/v1/`;
window.kazangHelpDeskApi = `http://localhost:8090/api/v1/`;
window.reportTomcatApi = `https://overflow.pos.co.zm/ReportsApi/`;
window.reportsApi = reportTomcatApi+`api/v2/cashup/`
// window.developmentMode = true;
window.developmentMode = false;
Vue.prototype.$dateTimeManager = dateTimeManager;
window.auth = authentication;
window.Device = Device;
window.Imeis = Imeis;
// Native Kazang APKs inject window.Imei (real device IMEI). On web/PC there is
// no plugin — shim it so development mode gets a stable generated local ID
// persisted under the legacy `_capuid` key, instead of a ReferenceError.
// (Pattern from LytSoft POS Mobile V2. Payments keep the Imeis shim fallback.)
// if (!window.Imei) {
//     window.Imei = {
//         get: () => {
//             if (!window.developmentMode) return null;
//             let id = null;
//             try { id = localStorage.getItem('_capuid'); } catch (e) {}
//             if (!id) {
//                 id = window.generateUUID();
//                 try { localStorage.setItem('_capuid', id); } catch (e) {}
//             }
//             return id;
//         }
//     };
// }
window.responses = responses;
window.errorHandler = errorHandler
window.routeExceptions = ['login','forgot-password','kazangOnline','test-success','test-failed','initKazangOnline',
    'signup','custom-install','custom-cart','system-expired','make-subscription-payment'];

const EventBus = new Vue()
window.EventBus = EventBus
window.log = (val) => console.log(val);
window.Swal = Swal;
window.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

window.$utils = utils;
Vue.prototype.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);
window.encryptObj = (object) => window.btoa(JSON.stringify(object));

window.openUrl = (url,target = '_blank') => window.open(url,target);
window.isValidString = (string) => {
    if (!string) return false;
    string = string.toString().trim();
    return !(string === `null` || string === `undefined` || string === ``);

}
window.stripMimeType = (base64) => {
    const pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
    return base64.replace(pattern, '');
}

window.requestPersistentStorage = async () => {
    console.log("Requesting persistent storage...");
    console.log("Secure context:", window.isSecureContext);
    console.log("Persist API available:", typeof navigator.storage?.persist);
    console.log("Trigger from user gesture:", document.hasFocus());

    if ('storage' in navigator && typeof navigator.storage.persist === 'function') {
        const isPersistent = await navigator.storage.persisted();
        if (isPersistent) {
            console.log("📦 Already persistent");
            return true;
        }

        const granted = await navigator.storage.persist();
        console.log(granted ? "✅ Persistent storage granted!" : "❌ Storage persistence denied.");
        return granted;
    } else {
        console.warn("🚫 Persistent storage not supported.");
        return false;
    }
}

// Global announcements configuration (used by App.vue)
window.ANNOUNCEMENTS = {
    small: {
        id: 'announcement-small-2026-02-09',
        enabled: false,
        title: 'Kazang POS App Notice',
        message: 'The Kazang POS app license price will increase to K200 per month.',
        ctaLabel: '',
        ctaUrl: '',
    },
    large: {
        id: 'announcement-large-2026-02-09',
        // License-price-increase campaign concluded — popup no longer shown to cashiers on login.
        enabled: false,
        title: 'Kazang POS App Notice',
        message: 'The Kazang POS app license price will increase to K200 per month.',
        ctaLabel: 'OK',
        ctaUrl: '',
    }
};


